import {
    PDF_LOADING,
    PDF_LOADED,
    PDF_ERROR
  } from './../../types/pdf';

const INITIAL_STATE = {
    pdfLoading: false,
    pdfLoaded: false,
    pdf: [],
    pdferror: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case PDF_LOADING:
            return {
                ... state,
                pdfLoading : true,
                pdfLoaded : false,
                pdf: [],
                pdferror: ''
            }
        case PDF_LOADED:
            return {
                ...state,
                pdfLoading : false,
                pdfLoaded : true,
                pdf: action.payload,
                pdferror: ''
            };
        case PDF_ERROR:
            return {
                ...state,
                pdfLoading : false,
                pdfLoaded : true,
                pdf: [],
                pdferror: action.payload
            }

        default: return state;
    }
}